module.exports = __webpack_public_path__ + "img/微信图片_20240409161717.7449cbf1.jpg";